module.exports = __webpack_public_path__ + "static/media/macbook-air-creating-setlist-dark-reduced.47ba31f5.png";